import {patchState, signalStore, withComputed, withMethods, withState} from "@ngrx/signals";
import {computed} from "@angular/core";

export type YoutubePlayerStore = {
  videoDuration: number;
  videoTime: number;
  isPlaying: boolean;
}

const initialState: YoutubePlayerStore = {
  videoDuration: 0,
  videoTime: 0,
  isPlaying: false
}

export const YoutubePlayerStore = signalStore(
  withState(initialState),
  withComputed(store => ({
    progressPercentage: computed(() => {
      const duration = store.videoDuration();
      const time = store.videoTime();
      return (time / duration) * 100;
    })
  })),
  withMethods((store) => ({
    reset(duration: number) {
      patchState(store, {
        videoDuration: duration,
        videoTime: 0
      });
    },
    setIsPlaying(isPlaying: boolean) {
      patchState(store, { isPlaying });
    },
    setVideoTime(videoTime: number) {
      patchState(store, { videoTime });
    }
  }))
);
